const experienceData = [
  {
    companyName: "Citoto",
    role: "Mobile Developer Intern",
    technologies: "Flutter, Firebase",
    duration: "3 Months",
    description: [
      { point: "Developed the Frontend application using Flutter framework." },
      {
        point:
          "Developed & enhanced multiple features with customizability option across app.",
      },
      { point: "Optimized the codebase of the app." },
      { point: "Provided application maintenance while working ." },
      {
        point:
          "Performed CRUD operations on Firestore to load/ remove data according to the business requirements.",
      },
      {
        point:
          "Developed Work Ethics and completing the assigned task on time.",
      },
    ],
  },
  // {
  //   companyName: "",
  //   role: "",
  //   technologies: "",
  //   duration: "",
  //   description: [],
  // },
];

export default experienceData;
